import { Empty } from "antd-mobile";
export default function CommonEmpty() {
  return (
    <div className="panel_empty_center">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<span style={{ color: "#cccccc" }}>暂无数据</span>}
      ></Empty>
    </div>
  );
}
